import React from 'react'
import saveIcon from '../../../assets/save.png'
import { FaDownload } from 'react-icons/fa'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger
} from '../../../components/Select/Select'

const Toolbar = ({
  onBack,
  onReserve,
  onSave,
  onAddBlackCircle,
  onConfirm,
  onLogClear,
  onLogToggle,
  onOrderToggle,
  onClose,
  onUndo,
  onRedo,
  isLogOpen,
  isOrderOpen,
  currentLogIndex,
  changeLog,
  canSave = false,
  isReadOnly = false,
  canDownloadExcel = false,
  canDownloadFinalFiles = false,
  onGetPrices,
  onDownLoadExcel,
  onReAllocate,
  onDownLoadDB,
  hasUnsavedChanges = false,
  farmFilterValues = [],
  farmFilterOptions = [],
  onFarmFilterChange
}) => {
  const excelDisabledTitle = hasUnsavedChanges
    ? '保存してからダウンロードしてください'
    : !canDownloadExcel
      ? '保存してからダウンロードしてください'
      : undefined
  const finalFilesDisabledTitle = hasUnsavedChanges
    ? '保存してからダウンロードしてください'
    : !canDownloadFinalFiles
      ? '確定してからダウンロードしてください'
      : undefined
  const editDisabled = isReadOnly || !canSave
  const excelDownloadDisabled = !canDownloadExcel
  const finalFilesDownloadDisabled = !canDownloadFinalFiles
  const selectedFarmLabel =
    farmFilterValues.length > 0 ? `${farmFilterValues.length}件選択` : 'すべて'

  const toggleFarmFilter = (value) => {
    onFarmFilterChange((currentValues) =>
      currentValues.includes(value)
        ? currentValues.filter((currentValue) => currentValue !== value)
        : [...currentValues, value]
    )
  }

  const clearFarmFilter = () =>
    onFarmFilterChange((currentValues) =>
      currentValues.length > 0 ? [] : currentValues
    )

  const handleClearFarmFilter = (event) => {
    event.stopPropagation()
    clearFarmFilter()
  }
  return (
    <div className='flex flex-wrap items-center gap-1.5 px-2 py-1.5 border-b bg-white'>
      <span className='font-bold text-base text-[#333] whitespace-nowrap mr-1'>
        荷割結果
      </span>

      <Btn onClick={onBack} ghost>
        <ChevronLeft /> 戻る
      </Btn>

      <Btn onClick={onReserve} color='#1976d2' disabled={isReadOnly}>
        <CalendarIcon /> 残数
      </Btn>

      <Btn onClick={onSave} color='#455a64' disabled={editDisabled}>
        <img src={saveIcon} alt='' style={{ width: 15, height: 15 }} />
        保存
      </Btn>

      <Btn onClick={onConfirm} color='#d32f2f' disabled={editDisabled}>
        <CheckIcon /> 荷割確定
      </Btn>

      <Divider />

      <Btn
        onClick={onUndo}
        ghost
        disabled={
          isReadOnly ||
          currentLogIndex < 0 ||
          changeLog[currentLogIndex]?.changeData?.type === 'initial'
        }
      >
        <ChevronLeft /> 元に戻す
      </Btn>

      <Btn
        onClick={onRedo}
        ghost
        disabled={isReadOnly || currentLogIndex >= changeLog.length - 1}
      >
        やり直す <ChevronRight />
      </Btn>

      <Divider />

      <Btn onClick={onAddBlackCircle} ghost disabled={isReadOnly}>
        <PlusIcon /> 全部●
      </Btn>

      <Btn onClick={onGetPrices} ghost disabled={isReadOnly}>
        価格取得
      </Btn>

      <div className='w-56'>
        <Select
          value={farmFilterValues}
          onValueChange={toggleFarmFilter}
          closeOnSelect={false}
        >
          <SelectTrigger>
            <Btn ghost className='w-full min-w-0'>
              <span className='shrink-0'>出荷者:</span>
              <span
                className='min-w-0 flex-1 truncate text-left'
                title={selectedFarmLabel}
              >
                {selectedFarmLabel}
              </span>
              <ChevronDown />
            </Btn>
          </SelectTrigger>
          <SelectContent
            className='min-w-full w-max max-w-[calc(100vw-2rem)] max-h-[280px] overflow-y-auto'
            style={{ zIndex: 200 }}
          >
            <div className='sticky top-0 z-10 border-b bg-white px-3 py-2'>
              <button
                type='button'
                onPointerDown={handleClearFarmFilter}
                onClick={handleClearFarmFilter}
                disabled={farmFilterValues.length === 0}
                className='text-sm text-blue-600 hover:underline disabled:cursor-not-allowed disabled:text-gray-400 disabled:no-underline'
              >
                選択を解除
              </button>
            </div>
            {farmFilterOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                <span className='flex items-start gap-2 whitespace-normal break-all'>
                  <input
                    type='checkbox'
                    checked={farmFilterValues.includes(option.value)}
                    readOnly
                    tabIndex={-1}
                    className='mt-0.5 shrink-0 pointer-events-none'
                  />
                  <span>{option.label}</span>
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div title={excelDisabledTitle}>
        <Btn onClick={onDownLoadExcel} ghost disabled={excelDownloadDisabled}>
          <FaDownload /> Excelダウンロード
        </Btn>
      </div>

      <div title={finalFilesDisabledTitle}>
        <Select
          onValueChange={finalFilesDownloadDisabled ? undefined : onDownLoadDB}
          disabled={finalFilesDownloadDisabled}
        >
          <SelectTrigger>
            <Btn ghost disabled={finalFilesDownloadDisabled}>
              <FaDownload /> DBダウンロード <ChevronDown />
            </Btn>
          </SelectTrigger>
          {!finalFilesDownloadDisabled && (
            <SelectContent style={{ zIndex: 9999 }}>
              <SelectItem value='excel_download'>
                ExcelDB ダウンロード（PC）
              </SelectItem>
              <SelectItem value='excel_gcp'>
                ExcelDB アップロード（GCP）
              </SelectItem>
            </SelectContent>
          )}
        </Select>
      </div>

      {/* <Btn onClick={onReAllocate} ghost>
        再荷割
      </Btn> */}

      <Divider />

      <Btn onClick={onLogClear} ghost disabled={isReadOnly}>
        <TrashIcon /> LOGクリア
      </Btn>

      <Btn onClick={onLogToggle} ghost>
        {isLogOpen ? <EyeIcon /> : <EyeOffIcon />}
        {isLogOpen ? 'LOG非表示' : 'LOG表示'}
      </Btn>

      <Btn onClick={onOrderToggle} ghost>
        {isOrderOpen ? <EyeIcon /> : <EyeOffIcon />}
        {isOrderOpen ? 'ORDER非表示' : 'ORDER表示'}
      </Btn>

      <Btn onClick={onClose} ghost>
        <XIcon /> 閉じる
      </Btn>
    </div>
  )
}

const Btn = ({
  children,
  onClick,
  ghost,
  color,
  disabled,
  small,
  className = ''
}) => {
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: small ? '5px 10px' : '6px 12px',
    fontSize: small ? 13 : 15,
    fontWeight: 500,
    borderRadius: 6,
    border: '1px solid transparent',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.45 : 1,
    whiteSpace: 'nowrap',
    lineHeight: 1.4,
    transition: 'background 0.15s, border-color 0.15s',
    userSelect: 'none',
    ...(ghost
      ? {
          background: '#f5f5f5',
          color: '#333',
          borderColor: '#ddd'
        }
      : {
          background: color || '#1976d2',
          color: '#fff',
          borderColor: 'transparent'
        })
  }

  return (
    <button
      type='button'
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={base}
      className={className}
      onMouseEnter={(e) => {
        if (disabled) return
        e.currentTarget.style.filter = 'brightness(0.93)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.filter = 'none'
      }}
    >
      {children}
    </button>
  )
}

const Divider = () => (
  <span
    style={{
      display: 'inline-block',
      width: 1,
      height: 20,
      background: '#ddd',
      margin: '0 2px',
      flexShrink: 0
    }}
  />
)

const iconProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  width: 16,
  height: 16,
  style: { flexShrink: 0 }
}

const ChevronLeft = () => (
  <svg {...iconProps}>
    <path d='M15 18l-6-6 6-6' />
  </svg>
)
const ChevronRight = () => (
  <svg {...iconProps}>
    <path d='M9 18l6-6-6-6' />
  </svg>
)
const CheckIcon = () => (
  <svg {...iconProps}>
    <path d='M20 6L9 17l-5-5' />
  </svg>
)
const PlusIcon = () => (
  <svg {...iconProps}>
    <path d='M12 5v14M5 12h14' />
  </svg>
)
const XIcon = () => (
  <svg {...iconProps}>
    <path d='M18 6L6 18M6 6l12 12' />
  </svg>
)
const TrashIcon = () => (
  <svg {...iconProps}>
    <path d='M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6' />
  </svg>
)
const EyeIcon = () => (
  <svg {...iconProps}>
    <path d='M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z' />
    <circle cx='12' cy='12' r='3' />
  </svg>
)
const EyeOffIcon = () => (
  <svg {...iconProps}>
    <path d='M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.7 21.7 0 0 1 5.06-5.94M1 1l22 22M9.9 9.9A3 3 0 0 0 12 15a3 3 0 0 0 2.1-.9' />
  </svg>
)
const CalendarIcon = () => (
  <svg {...iconProps}>
    <path d='M19 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2z' />
    <path d='M16 3v4M8 3v4M3 11h18' />
  </svg>
)

const ChevronDown = () => (
  <svg {...iconProps}>
    <path d='M6 9l6 6 6-6' />
  </svg>
)

export default React.memo(Toolbar)
